<app-general *ngIf="canAccess('mis-novedades')"></app-general>

<h2 class="main-subtitle my-4">Novedades > Movimiento de productos</h2>

<mat-tab-group animationDuration="0ms">
  <mat-tab label="Novedades">
    <button class="button button-primary button-sm" (click)="newUpdateRecord('novedades')">
      Nueva novedad
    </button>
    <app-table class="table-news table-switch" [columns]="tableColumns" [data]="flattenedData['novedades']" [tableType]="'novedades'" (checkboxChange)="onCheckboxChange($event.checked, $event.id)" (selectAllChange)="onSelectAllChange($event)">
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="">
          </button>
          <button *ngIf="canEdit(visation)" (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button *ngIf="canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>

  <mat-tab label="Aviso de averías solicitado">
    <button class="button button-primary button-sm" (click)="newUpdateRecord('aviso_averias')">
      Nueva novedad
    </button>
    <app-table class="table-news table-switch" [columns]="tableColumns" [data]="flattenedData['aviso_averias']" [tableType]="'aviso_averias'" (checkboxChange)="onCheckboxChange($event.checked, $event.id)" (selectAllChange)="onSelectAllChange($event)">
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="">
          </button>
          <button *ngIf="canEdit(visation)" (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button *ngIf="canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>

  <mat-tab label="O/T Ejecutadas o en trabajos">
    <button class="button button-primary button-sm" (click)="newUpdateRecord('o_t_ejecutadas')">
      Nueva novedad
    </button>
    <app-table class="table-news table-switch" [columns]="tableColumns" [data]="flattenedData['o_t_ejecutadas']" [tableType]="'o_t_ejecutadas'" (checkboxChange)="onCheckboxChange($event.checked, $event.id)" (selectAllChange)="onSelectAllChange($event)">
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="">
          </button>
          <button *ngIf="canEdit(visation)" (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button *ngIf="canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>
    
  <mat-tab label="Fuera de servicios">
    <button class="button button-primary button-sm" (click)="newUpdateRecord('fuera_servicio')">
      Nueva novedad
    </button>
    <app-table class="table-news table-switch" [columns]="tableColumns" [data]="flattenedData['fuera_servicio']" [tableType]="'fuera_servicio'" (checkboxChange)="onCheckboxChange($event.checked, $event.id)" (selectAllChange)="onSelectAllChange($event)">
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="">
          </button>
          <button *ngIf="canEdit(visation)" (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button *ngIf="canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>
</mat-tab-group>